import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

const initialRole = 'ROLE_ADMIN'

export default new AclCreate({
  initial  : initialRole,
  notfound : '/',
  router,
  acceptLocalRules : true,
  globalRules: {
    ROLE_ADMIN  : new AclRule('ROLE_ADMIN').generate(),
    ROLE_SUPERVISOR : new AclRule('ROLE_SUPERVISOR').or('ROLE_ADMIN').generate(),
    ROLE_COMERCIAL : new AclRule('ROLE_COMERCIAL').or('ROLE_SUPERVISOR').or('ROLE_ADMIN').generate(),
    ROLE_USER: new AclRule('ROLE_USER').or('ROLE_COMERCIAL').or('ROLE_SUPERVISOR').or('ROLE_ADMIN').generate()
  }
})
